import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.addClickEventListener();
  }

  disconnect() {
    this.removeClickEventListener();
  }

  addClickEventListener() {
    this.scrollToTopOfResults = this.scrollToTopOfResults.bind(this);
    this.activePaginationLinks = document.querySelectorAll(".pagination a.page-link");
    this.activePaginationLinks.forEach((link) => {
      link.addEventListener("click", this.scrollToTopOfResults);
    });
  }

  removeClickEventListener() {
    if (this.activePaginationLinks) {
      this.activePaginationLinks.forEach((link) => {
        link.removeEventListener("click", this.scrollToTopOfResults);
      });
    }
  }

  scrollToTopOfResults() {
    const handleTurboLoad = () => {
      const element = document.getElementById("search_tabs");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };
    document.addEventListener("turbo:load", handleTurboLoad, { once: true });
  }
}
